import { AutomobilePlatformLiteApiModel } from '../infrastructure/models/automobile-platform-api.model';
import { AutomobilePlatformLite } from '../domain/AutomobilePlatform.model';

export function SetMapAutomobilePlatformsLite(
    automobilePlatforms: AutomobilePlatformLiteApiModel[]
): AutomobilePlatformLite[] {
    return automobilePlatforms.map(({
        ID,
        CreatedAt,
        UpdatedAt,
        DeletedAt,
        vin,
        isConfirmed,
        createdBy,
        updatedBy,
        ...rest
    }) => ({
        id: ID,
        createdAt: CreatedAt,
        updatedAt: UpdatedAt,
        deletedAt: DeletedAt,
        vin,
        isConfirmed,
        createdBy,
        updatedBy,
        ...rest
    }));
}